import React from 'react';

import classes from './SkipToContent.scss';

type SkipToContentProps = {
    href?: string;
    text?: string;
};

export const SkipToContent = (props: SkipToContentProps) => {
    const { href, text } = props;

    return (
        <a href={href ?? '#content'} className={classes['skipToContent']}>
            {text ?? 'Skip to Content'}
        </a>
    );
};

export default SkipToContent;
